import { combineReducers } from 'redux';

import { persistReducer } from 'Lib/persist';

import * as app from './app/reducer';
import * as appeals from './appeals/reducer';
import * as appSettings from './appSettings/reducer';
import * as context from './context/reducer';
import * as dynamicLoading from './dynamicLoading/reducer';
import * as email from './email/reducer';
import * as emailSubscriptionManagement from './emailSubscriptionManagement/reducer';
import * as entities from './entities/reducer';
import * as errors from './errors/reducer';
import * as facebook from './facebook/reducer';
import * as filters from './filters/reducer';
import * as intent from './intent/reducer';
import * as internationalization from './internationalization/reducer';
import * as intlMessages from './intlMessages/reducer';
import * as introPricing from './introPricing/reducer';
import * as line from './line/reducer';
import * as loading from './loading/reducer';
import * as location from './location/reducer';
import * as mfa from './mfa/reducer';
import * as modals from './modals/reducer';
import * as onboarding from './onboarding/reducer';
import * as privacy from './privacy/reducer';
import * as routing from './routing/reducer';
import * as session from './session/reducer';
import * as settings from './settings/reducer';
import * as sms from './sms/reducer';
import * as sparks from './sparks/reducer';
import * as user from './user/reducer';
import * as userBiometrics from './userBiometrics/reducer';
import * as webProfile from './webProfile/reducer';

const rootReducerModules = {
  app,
  appeals,
  appSettings,
  userBiometrics,
  context,
  dynamicLoading,
  email,
  emailSubscriptionManagement,
  entities,
  errors,
  facebook,
  filters,
  internationalization,
  intent,
  intlMessages,
  introPricing,
  line,
  loading,
  location,
  mfa,
  modals,
  onboarding,
  privacy,
  routing,
  session,
  settings,
  sms,
  sparks,
  user,
  webProfile,
};

export const rootReducerShape = {};

Object.entries(rootReducerModules).forEach(([name, { reducer, persistConfig }]) => {
  rootReducerShape[name] = !persistConfig
    ? reducer
    : persistReducer(
        {
          key: name,
          ...persistConfig,
        },
        reducer
      );
}, {});

export default combineReducers(rootReducerShape);
